// src/data/blogData.ts

export interface Post {
  id: number;
  title: string;
  titleKey?: string;
  excerpt: string;
  excerptKey?: string;
  content: string;
  contentKey?: string;
  date: string;
  views: string;
  thumbnail: string;
  slug: string;
  /** Search-engine title/description. Falls back to title/excerpt if omitted. */
  seoTitle?: string;
  seoDescription?: string;
}

export const blogPosts: Post[] = [
  {
    id: 1,
    title: "Inauguration Event",
    titleKey: "blog_inauguration_title",
    excerpt: "Minister of National Food Security and Research inaugurated our project at NARC",
    excerptKey: "blog_inauguration_excerpt",
    content: `
      Federal Minister Rana Tanveer Hussain officially inaugurated 
      Pakistan’s first intelligent and IoT-based greenhouse.
      This greenhouse integrates smart climate control, 
      automation systems, and precision agriculture technologies.
      The project marks a major step forward in sustainable farming.
    `,
    contentKey: "blog_inauguration_content",
    date: "Jan 15, 2024",
    views: "2.5k",
    thumbnail: "/s7.png",
    slug: "inauguration-event",
    seoTitle: "Pakistan's First IoT Greenhouse Inaugurated at NARC",
    seoDescription:
      "Federal Minister Rana Tanveer Hussain inaugurated Pakistan's first intelligent, IoT-based greenhouse at NARC, integrating smart climate control, automation and precision agriculture.",
  },
];
